import {Button, ButtonProps, Fade, Tooltip} from '@mui/material';
import {ReactNode, useState} from 'react';

import {PolicyFilter} from 'modules/decisionsNext/api/types';

import {TopbarFilterChip} from 'modules/decisionsNext/components/BaseFilter/TopBar/components/TopbarFilterChip';
import {PopoverOptions} from 'modules/decisionsNext/components/PopoverOptions';

export const BaseFilterTopBarItem = ({
  label,
  loading,
  variant,
  onClick,
  onDelete,
  disabled,
  tooltip,
  children,
  dropDownTitle,
  width,
  onApply,
  onCancel,
  onExited,
  visuallyHidden: hidden,
  primaryActionProps,
}: {
  label: ReactNode;
  variant?: 'primary' | 'secondary';
  loading?: boolean;
  onDelete?: () => void;
  onClick?: () => void;
  disabled?: boolean;
  tooltip?: ReactNode;
  children?: ReactNode;
  dropDownTitle?: string;
  onDropdownClose?: () => void;
  onApply?: () => void;
  onCancel?: () => void;
  onExited?: () => void;
  selectedNoneData?: Partial<PolicyFilter>;
  width?: number;
  visuallyHidden?: boolean;
  primaryActionProps?: ButtonProps;
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    if (children) {
      setAnchorEl(event.currentTarget);
    }

    onClick?.();
  };

  const handleClose = () => {
    setAnchorEl(null);
    onCancel?.();
  };

  const handleApply = () => {
    onApply?.();
    setAnchorEl(null);
  };

  const chip = (
    <TopbarFilterChip
      label={label}
      variant={variant}
      disabled={disabled}
      loading={loading}
      withDropdown={!!children}
      onDelete={onDelete}
      onClick={handleClick}
    />
  );

  return (
    <>
      <Tooltip title={!loading && tooltip}>{disabled ? chip : <Fade in={!hidden}>{chip}</Fade>}</Tooltip>

      {children && (
        <PopoverOptions
          anchorEl={anchorEl}
          onClose={handleClose}
          onExited={onExited}
          title={dropDownTitle}
          width={width}
          footer={
            <>
              <Button variant='text' size='small' color='inherit' onClick={handleClose}>
                Cancel
              </Button>

              <Button
                variant='text'
                size='small'
                color='inherit'
                data-apply
                onClick={handleApply}
                {...primaryActionProps}
              >
                Apply
              </Button>
            </>
          }
        >
          {children}
        </PopoverOptions>
      )}
    </>
  );
};
